// Eliminazioni singole: la versione della riga (quella letta con l'elenco) va sempre inviata. Se un altro operatore l'ha modificata nel
// frattempo il server risponde 409 e la riga NON si elimina: si mostra chi l'ha cambiata e si ricarica l'elenco.
import { eConflitto } from '../components/ConflittoVersione';

// Deadlock o timeout del database: 409/503 con codice RIPROVA (non è un conflitto di versione: niente Ricarica/Sovrascrivi)
export const eRiprova = (err) => [409, 503].includes(err?.response?.status) && err.response.data?.codice === 'RIPROVA';

export const urlEliminazione = (url, version) => `${url}?version=${encodeURIComponent(version)}`;

export function messaggioEliminazione(err, predefinito = 'Eliminazione non riuscita') {
  if (eConflitto(err)) return `Non eliminata: ${err.response.data.errore}. Ricarica l'elenco e controlla prima di eliminare.`;
  return err?.response?.data?.errore || predefinito;
}

// Altre azioni sulla riga (disattivare, riattivare, togliere): stesso criterio, messaggio dedicato al 409
export function messaggioAzione(err, predefinito = 'Operazione non riuscita') {
  if (eConflitto(err)) return `Operazione non eseguita: ${err.response.data.errore}. Ricarica l'elenco e controlla prima di continuare.`;
  return err?.response?.data?.errore || predefinito;
}

// Un'azione rifiutata per conflitto (riga modificata da un altro) si segnala SEMPRE con una finestra che blocca: il messaggio in cima alla pagina può
// restare fuori dallo schermo e chi non lo vede riprova alla cieca. Restituisce il messaggio, da mostrare anche nella pagina.
export function avvisaConflitto(err, messaggio) {
  if (eConflitto(err) || eRiprova(err)) window.alert(messaggio);
  return messaggio;
}

export { eConflitto };
